
  <div class="InventoryCounts Inventory">
    <div class="fx-xs-column fx-row fx-align-space-between-center">
      <div class="fx-row fx-align-start-center fx-flex-30">
        <app-count-header title="{{inventory?.invBatchName}}"></app-count-header>
      </div>
      <h2 class="text-center fx-flex-30">{{ "inventory.title.count" | translate }}</h2>
      <div class="flex fx-align-end-center fx-flex-30">
        <div class="fx-layout-lt-md-column fx-row fx-gap-20px">
          <button mat-raised-button color="primary" (click)="sendReport()" class="fx-align-simple-center">
            {{ "sendReport" | translate }}
          </button>
          <app-select-report></app-select-report>
          <button mat-raised-button color="primary" (click)="generatePDF()" class="fx-align-simple-center">
            {{ "generatePDF" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-mid-header [inventory]="inventory"></app-mid-header>
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortData($event)" matSortActive="prdNameEn" matSortDirection="asc"  width="100%"
      id="main-table">
      <ng-container matColumnDef="prdCode">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "products.table.prdCode" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex-header">
          <span class="mobile-label">{{ "products.table.prdCode" | translate }}</span>
          <span [innerHTML]="element.prdCode"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdNameEn">
        <mat-header-cell *matHeaderCellDef mat-sort-header="prdNameEn"> {{ "products.table.prdNameEn" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex-header">
          <span class="mobile-label">{{ "products.table.prdNameEn" | translate }}</span>
          <span [innerHTML]="element.prdNameEn"></span>
          <span *ngIf="element.isCombined" style="color: red;">*</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdCasePack">
        <mat-header-cell *matHeaderCellDef mat-sort-header="prdCasePack">UOM</mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex-header">
          <span class="mobile-label">UOM</span>
          <span>{{element.prdCasePack}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="invitmCount">
        <mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header="invitmCount"> {{ "inventory.count" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="text-center flex-header">
          <span class="mobile-label">{{ "inventory.count" | translate }}</span>
          <span>{{ element.invitmCount }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdCustomField1" *ngIf="settings$?.locEnableCustomField1">
        <mat-header-cell *matHeaderCellDef mat-sort-header="prdCustomField1" class="text-center"> {{ locPrdCustomFieldLabel1$ }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="text-center flex-header">
          <span class="mobile-label">{{ locPrdCustomFieldLabel1$ }}</span>
          <span [innerHTML]="element?.prdCustomField1"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdCustomField2" *ngIf="settings$?.locEnableCustomField2">
        <mat-header-cell *matHeaderCellDef mat-sort-header="prdCustomField2" class="text-center"> {{ locPrdCustomFieldLabel2$ }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="text-center flex-header">
          <span class="mobile-label">{{ locPrdCustomFieldLabel2$ }}</span>
          <span [innerHTML]="element?.prdCustomField2"></span>
        </mat-cell>
      </ng-container>

      
      <ng-container matColumnDef="checkRemove">
        <mat-header-cell *matHeaderCellDef class="flex-header pointer"></mat-header-cell>
        <mat-cell *matCellDef="let row" class="last-column">
            <i class="fa fa-trash-o" aria-hidden="true" style="color:#E57373"></i>
            <mat-icon _ngcontent-mlp-c400="" role="img" class="mat-icon notranslate material-icons mat-icon-no-color last-column" 
            aria-hidden="true" data-mat-icon-type="font" style="color: #E57373;">delete_outline</mat-icon>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onContextMenu($event, row)" class="lt-sm-row"></mat-row>
      <div *ngIf="dataSource.length == 0">
        No Records Found!
      </div>
    </table>

    <br />
    <br />
    <table class="bottom-table">
      <thead>
        <tr>
          <th>{{ "productsCounted" | translate }}</th>
          <th>{{ "unitsCounted" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{count}}</td>
          <td>{{sum?.toFixed(2)}}</td>
        </tr>
      </tbody>
    </table>
    <table class="bottom-table alert-message" *ngIf="hasAsteriskProducts">
        <tr>
          <td>{{ "message_asterisk" | translate }}</td>
        </tr>
    </table>